import { Component,
    Input,
    ElementRef,
    AfterViewInit,
    TemplateRef,
    ChangeDetectorRef,
    ViewEncapsulation
} from '@angular/core';
import { TreeNode } from '../models/tree-node.model';
import { LoaderComponent } from './loader.component';
import { TreeNodeIcon } from './tree-node-icon.component';
import { Subject } from 'rxjs/Subject';
import { ContextMenuDirective } from '../../context-menu/context-menu.directive';

export interface ITreeNodeTemplate {
    node: TreeNode;
    context: any;
}

@Component({
    selector: 'TreeNode',
    styles: [require('./tree-node.scss')],
    template: require('./tree-node.html'),
    encapsulation: ViewEncapsulation.None
})

export class TreeNodeComponent implements AfterViewInit {
    @Input() node: TreeNode;
    @Input() treeNodeContentTemplate: TemplateRef<ITreeNodeTemplate>;
    @Input() loadingTemplate: TemplateRef<any>;
    @Input() iconTemplate: any;
    @Input() index: number;

    links;

    constructor(private elementRef: ElementRef, private changeDetectionRef : ChangeDetectorRef) {
        this.links = [];
    }

    ngAfterViewInit() {
        this.node.elementRef = this.elementRef;
        // TODO - Disable contextmenu for nodes not found in the mapping
        if (this.node.options.hasContextMenu && this.node.options.menuLinksMapping) {
            this.links = this.node.options.menuLinksMapping[this.node.data.type];
            if (this.links && this.links.length) {
                this.links.forEach(l => {
                    l.subject = new Subject<{ event: MouseEvent, obj: any[] }>();
                });
                this.links.forEach(l => {
                    l.subject.subscribe(val => this.menuItemClick(val));
                });
            }
        }
        this.changeDetectionRef.detectChanges();
    }

    ngOnDestroy () {
        if (this.links && this.links.length) {
            this.links.forEach(l => l.subject.unsubscribe());
        }
    }

    menuItemClick(val) {
        if (this.node.contextmenu) {
            this.node.contextmenu({linkName: val, node: this.node});
        }
    }
    getDisplayField(str: string) {
        return str;
    }
}



// WEBPACK FOOTER //
// ./src/common/tree/components/tree-node.component.ts